require('../../modules/es7.object.entries');
module.exports = require('../../modules/$.core').Object.entries;


//////////////////
// WEBPACK FOOTER
// C:/wamp/www/node_modules/core-js/library/fn/object/entries.js
// module id = 254
// module chunks = 0